import { InAppCredits } from "../../types/mailcredit";
import { generateAPI } from "../api.generator";

export const getInAppCredits = generateAPI<{}, InAppCredits>("get", "mail-credits/in-app-credits");
